import * as types from './types'
import UserResource from '@/resources/User'
// import AnonymousResource from '@/resources/Anonymous'
import emma from '@/common/services/Emma'

const manageLogin = (commit, dispatch, user) => {
	// get Advisors
	// get Patrimonial
	return new Promise((resolve, reject) => {
		let userToLog = null
		dispatch('allClear').then(() => {
			return UserResource.login(user.email, user.password)
		}).then((result) => {
			if (result.data.success) {
				// this is secure :kappa:
				if (result.data.user.roles.indexOf('ROLE_CLIENT') === -1 && result.data.user.roles.indexOf('ROLE_ANONYMOUS') === -1) reject(new Error('Mauvais login/mot de passe'))
				userToLog = result.data.user
				emma.setToken(result.data.refresh_token, result.data.token)
				commit(types.LOGIN, result.data)
				userToLog.office.tags.forEach((tag) => {
					commit('ADD_GENERAL_TAG', tag)
				})
				userToLog.user_tags.forEach((tag) => {
					commit('ADD_USER_TAG', tag.tags)
				})
				return dispatch('getPatrimonial', userToLog.id)
			} else {
				reject(new Error('Votre compte n\'est pas rataché à ce cabinet'))
			}
		}).then(() => {
			resolve()
		}).catch(() => {
			reject(new Error('Problème de login ou de mot de passe'))
		})
	})
}

export const actions = {
	allClear ({ commit }) {
		return new Promise((resolve) => {
			commit('LOGOUT')
			commit('CLEAR')
			commit('CLEAR_THREAD')
			commit('CLOSE_NOTIF')
			commit('CLEAR_TAGS')
			commit('CLEAR_ARTICLES')
			resolve()
		})
	},
	login ({ commit, dispatch }, user) {
		return new Promise((resolve, reject) => {
			manageLogin(commit, dispatch, user).then(() => {
				return UserResource.getProfile()
			}).then((result) => {
				let userToLog = {}
				userToLog.firstname = result.data.user.first_name
				userToLog.lastname = result.data.user.last_name
				userToLog.id = result.data.user.id
				userToLog.isEstate = (result.data.completed_estate !== 0)
				if (result.data.user.media) {
					userToLog.picture = result.data.user.media.file
				}
				userToLog.address = {
					line: result.data.user.address,
					zip: result.data.user.zipcode,
					city: result.data.user.city,
					country: result.data.user.country
				}
				userToLog.phone = result.data.user.phone
				userToLog.birthdate = result.data.user.birthdate.split('-').reverse().join('-')
				commit(types.UPDATE_PROFILE, userToLog)
				commit(types.PROFIL_PICTURE, { image: userToLog.picture })
				return dispatch('getAdvisors').then((result) => {
					dispatch('getInvestmentStats')
				})
			}).then(() => {
				resolve()
			}).catch((error) => {
				reject(error)
			})
		})
	},
	anonymousLogin ({ commit, dispatch }, data) {
		return manageLogin(commit, dispatch, data)
	},
	logout ({ dispatch }) {
		return new Promise((resolve) => {
			UserResource.logout().then(() => {
				dispatch('allClear')
				resolve()
			}).catch(() => {
				dispatch('allClear')
				resolve()
			})
		})
	},
	updateProfilePicture ({ commit, state }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateProfilePicture(data, state.id).then((response) => {
				commit('LOADER_OUT')
				commit(types.PROFIL_PICTURE, response.data)
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	saveProfile ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateProfile(data).then(() => {
				commit('LOADER_OUT')
				commit(types.UPDATE_PROFILE, data)
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editPassword ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.editPassword(data).then((response) => {
				commit('LOADER_OUT')
				if (response.status === 201) {
					resolve(response)
				} else {
					reject(new Error())
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getAdvisors ({ commit, state }) {
		return new Promise((resolve, reject) => {
			UserResource.getAdvisors(state.id).then((response) => {
				commit(types.GET_ADVISORS, response.data.advisors)
				resolve()
			}).catch((error) => {
				reject(error)
			})
		})
	},
	getInvestmentStats ({ commit }) {
		return new Promise((resolve, reject) => {
			UserResource.getInvestmentStats().then((response) => {
				commit(types.GET_INVESTMENT_STATS, response.data.investment_stats)
				resolve()
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateTutorialFinished ({ commit }, isFinished) {
		return new Promise((resolve, reject) => {
			UserResource.updateTutorialFinished(isFinished).then((response) => {
				commit(types.TUTORIAL_FINISHED)
				resolve()
			}).catch((error) => {
				reject(error)
			})
		})
	},
	setForceCompleteProfileAsTrue ({ commit }) {
		return new Promise((resolve, reject) => {
			commit(types.FORCE_COMPLETE_PROFILE)
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/actions.js